import { render, staticRenderFns } from "./IndustryGrowthStatement.vue?vue&type=template&id=24c3f1d6"
import script from "./IndustryGrowthStatement.vue?vue&type=script&lang=js"
export * from "./IndustryGrowthStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VisualCard: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/VisualCard.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default})
